import axios from "axios";
import { toast } from "react-toastify";

export const apiInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

apiInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    // Error toast tabhi show hoga jab manually handle na ho
    if (!error.config?.skipErrorToast && error?.response?.data?.message) {
      toast.error(error.response.data.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
    }
    return Promise.reject(error);
  }
);